import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import translations from "../translations";
import DonationLanguage from "./DonationLanguage";

const DonationFormBanner = ({language = 'NL'}) => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate("/");
  };
  const {t} = useTranslation()
  const lang = language || 'nl'
  return (
    <div className="login_banner donation_banner" style={{height:'250px'}}>
      <div className="container" style={{position:'relative'}}>
        <div className="logo_im"  style={{background: "white"}}  onClick={() => handleRedirect()}>
          <img className="donation_logo" src="/assets/mosqapp-logo-new.svg"/>
        </div>
        <br/>
        <div className="login_content donation_content">
          <h3>{t('HELP YOUR MOSQUE')}</h3>
          {/* <p style={{width:'600px', margin:'0 auto'}}>
          {t('Either late when Stenorat listens in. Especially this time. Chaotic/damaged label, super-magnificent and gigantic.')}
          </p> */}
          
        </div>
        <div style={{position:'absolute',top:'20px',right:'50px'}}><DonationLanguage/></div>
      </div>
      
    </div>
  );
};

export default DonationFormBanner;
